import { useMutation } from '@tanstack/react-query';
import { updateContactAddress } from '../../services/fn-api/User';

export const useUpdateContactAddress = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (contactAddress) => {
      const { createdDate, ...data } = contactAddress;
      return updateContactAddress(data);
    },
  });
};
